export const PLACEMENT_TOP = 'top';
export const PLACEMENT_BOTTOM = 'bottom';
export const PLACEMENT_LEFT = 'left';
export const PLACEMENT_RIGHT = 'right';
